export const PHONE_QC = "1-438-500-5225";
export const PHONE_DEFAULT = "1-403-768-2298";